export const DISPATCH_PATCH_PROFILE_INFO = "DISPATCH_PATCH_PROFILE_INFO";

export const DISPATCH_PATCH_ACCOUNT_INFO = "DISPATCH_PATCH_ACCOUNT_INFO";
